import dayjs from 'dayjs'
import i18next, { TFunction } from 'i18next'
import { TimespanOption } from '../../chartUtils/hooks/useChartTime'
import { TimePeriodResolution } from '../../../../utils/timePeriod'

export interface PriceData {
	hour?: number
	day?: number
	month?: number
	price: number
	date?: string
	minute?: number // Added minute field for quarter-hourly data
}

export const getTitle = (
	resolution: TimePeriodResolution,
	t: TFunction<'pages_electricity', undefined>
) => {
	switch (resolution) {
		case 'day':
			return t('hourlyPrice.hourlyPrices')
		case 'week':
			return t('hourlyPrice.dailyPrices')
		case 'month':
			return t('hourlyPrice.dailyPrices')
		case 'year':
			return t('hourlyPrice.monthlyPrices')
		default:
			return t('hourlyPrice.prices')
	}
}

export const getButtonText = (
	showAll: boolean,
	resolution: TimePeriodResolution,
	t: TFunction<'pages_electricity', undefined>
) => {
	if (showAll) {
		switch (resolution) {
			case 'day':
				return t('hourlyPrice.hideHours')
			case 'week':
				return t('hourlyPrice.hideDays')
			case 'month':
				return t('hourlyPrice.hideDays')
			case 'year':
				return t('hourlyPrice.hideMonths')
			default:
				return t('hourlyPrice.hide')
		}
	} else {
		switch (resolution) {
			case 'day':
				return t('hourlyPrice.showHours')
			case 'week':
				return t('hourlyPrice.showDays')
			case 'month':
				return t('hourlyPrice.showDays')
			case 'year':
				return t('hourlyPrice.showMonths')
			default:
				return t('hourlyPrice.show')
		}
	}
}

export const getCurrentLabel = (
	resolution: TimePeriodResolution,
	t: TFunction<'pages_electricity', undefined>
) => {
	switch (resolution) {
		case 'day':
			return t('hourlyPrice.now')
		case 'week':
			return t('hourlyPrice.today')
		case 'month':
			return t('hourlyPrice.today')
		case 'year':
			return t('hourlyPrice.thisMonth')
		default:
			return t('hourlyPrice.now')
	}
}

export const getTimeDisplay = (
	data: PriceData,
	timespan: TimespanOption,
	isQuarterHourly?: boolean
) => {
	switch (timespan) {
		case 'day':
			if (isQuarterHourly) {
				return `${data.hour}:${(data.minute ?? 0).toString().padStart(2, '0')}`
			} else {
				return `${data.hour}:00`
			}
		case 'week':
			if (data.date) {
				return dayjs(data.date).format('DD.MM')
			}
			return `${data.day}`
		case 'month':
			if (data.date) {
				return dayjs(data.date).format('DD.MM')
			}
			return `${data.day}`
		case 'year':
			if (data.date) {
				return (
					dayjs(data.date).locale(i18next.language).format('MMMM').charAt(0).toUpperCase() +
					dayjs(data.date).locale(i18next.language).format('MMMM').slice(1)
				)
			}
			return `${data.month}`
		default:
			return '-'
	}
}
